import {
  FabricEditor,
  gridPlugin,
  layerPlugin,
  rectCornersPlugin,
  selectionPlugin,
  vignettePlugin,
} from 'modules/fabric-editor';
import { layoutBlocksPlugin } from 'modules/manager/domain/layout-blocks';
import { placeholderPlugin } from 'modules/manager/domain/placeholder';
import React from 'react';

/** Plugin set for headless (off-screen) render pages — shared by the match and standings renderers. */
export const RENDER_PLUGINS = [
  selectionPlugin(),
  layerPlugin(),
  gridPlugin({ visible: false }),
  rectCornersPlugin(),
  vignettePlugin(),
  placeholderPlugin(),
  layoutBlocksPlugin(),
];

export type RenderStatus = 'loading' | 'rendering' | 'done' | 'error';

export const StatusOverlay: React.FC<{ status: string; message: string | null; title: (status: string) => string }> = ({
  status,
  message,
  title,
}) => (
  <div className="flex items-center justify-center w-screen h-screen text-gray-600">
    <div className="text-center">
      <div className="text-xl font-bold mb-2">{title(status)}</div>
      {message && <div className="text-sm">{message}</div>}
    </div>
  </div>
);

export function parseId(raw: string | null | undefined): number | null {
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function collectBgUrls(params: URLSearchParams): string[] {
  const out: string[] = [];
  for (let i = 1; i <= 50; i++) {
    const value = params.get(`bg${i}`);
    if (value === null) {
      if (i === 1) continue;
      break;
    }
    out.push(value);
  }
  return out;
}

export function loadCanvasJson(editor: FabricEditor, version: unknown, objects: unknown[]): Promise<void> {
  return new Promise((resolve) => {
    editor.canvas.loadFromJSON({ version, objects }, () => {
      editor.canvas.renderAll();
      editor.emit('canvas:loaded', { source: 'render' });
      resolve();
    });
  });
}

export function nextFrame(): Promise<void> {
  return new Promise((resolve) => {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => resolve());
    } else {
      setTimeout(resolve, 16);
    }
  });
}
